import { render, staticRenderFns } from "./SafaricomTransactionDetail.vue?vue&type=template&id=5599c90e&scoped=true"
import script from "./SafaricomTransactionDetail.vue?vue&type=script&lang=js"
export * from "./SafaricomTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./SafaricomTransactionDetail.vue?vue&type=style&index=0&id=5599c90e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5599c90e",
  null
  
)

export default component.exports